import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

import { PagesGenericStyling } from './PagesGenericStyling'

const {
  grid: { spacing, resolution },
} = theme

export const EntryStepsStyles = styled(PagesGenericStyling)`
  h1,
  h4 {
    margin-top: ${spacing.md}px;
    @media (min-width: ${resolution.desktop.width}px) {
      margin-top: ${spacing.l}px;
    }
  }
  .step-wrapper {
    margin-top: ${theme.grid.spacing.s}px;
  }
  .entry-step-component-wrapper {
    margin: ${spacing.base}px 0 ${spacing.md}px 0;
    @media (min-width: ${resolution.tablet.width}px) {
      margin-top: ${spacing.l}px;
    }
    @media (min-width: ${resolution.desktop.width}px) {
      margin-bottom: ${spacing.l}px;
    }
  }
  .link {
    text-decoration: underline;
    color: blue;
    overflow-wrap: break-word;
  }
  .car-wrapper {
    padding: ${spacing.s}px 0 ${theme.grid.spacing.md}px;
  }

  @media (max-width: ${resolution.mobile.width}px) {
    .continue-button {
      min-width: 100%;
    }
  }
`
